import * as moment from 'moment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, Observable, Subject } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import sort from 'fast-sort/sort.es5'
import { DaysUntilDuePipe } from 'app/shared/pipes';

import { 
  _CLEAR,
  CREATE_BATCH,
  CREATE_EOD,
  CREATE_DIE,
  CREATE_HORIZON,
  CREATE_HORIZON_STAT,
  CREATE_JOB,
  CREATE_ORDER,
  CREATE_SCRAP,
  CREATE_SHIPMENT,
  CREATE_YELLOWBAG,
  DELETE_BATCH,
  DELETE_DIE,
  DELETE_EOD,
  DELETE_HORIZON,
  DELETE_HORIZON_STAT,
  DELETE_QUEUED_MTS_JOB,
  DELETE_SCRAP,
  DATA_INIT,
  DELETE_JOB,
  DELETE_ORDER,
  DELETE_SHIPMENT,
  DELETE_YELLOWBAG,
  GET_ACTIVE_SCRAPS,
  GET_BATCHES,
  GET_BINS,
  GET_DIES,
  GET_EOD_HISTORY,
  GET_FILTERED_ORDERS,
  GET_HORIZONS,
  GET_HORIZON_STATS,
  GET_JOBS,
  GET_LAST_EOD_RAN_TODAY,
  GET_NEXT_BUSINESS_DAY,
  GET_ORDERS,
  GET_PRODUCTS,
  GET_QUEUED_MTS_JOBS,
  GET_RTS_TOTALS,
  GET_SETTINGS,
  GET_SHIPMENTS,
  GET_SORTED_OA_BATCHES,
  GET_SUBASSEMBLIES,
  GET_TEMPLATES,
  GET_TEMPLATE_PDFS,
  GET_USERS,
  SET_LOGIN_VIEW,
  SET_BATCH_DETAILS_VIEW,
  SET_BATCH_LIST_VIEW,
  SET_BINS_VIEW,
  SET_EOD_HISTORY_VIEW,
  SET_DIE_LIST_VIEW,
  SET_HOLD_LIST_VIEW,
  SET_JOB_LIST_VIEW,
  SET_JOB_DETAILS_VIEW,
  SET_MAIN_VIEW,
  SET_ORDER_LIST_VIEW,
  SET_ORDER_DETAILS_VIEW,
  SET_PRODUCT_LIST_VIEW,
  SET_PRODUCT_DETAILS_VIEW,
  SET_SCRAP_REPORT_VIEW,
  SET_SETTING_LIST_VIEW,
  SET_SHIPMENT_LIST_VIEW,
  SET_SHIPMENT_DETAILS_VIEW,
  SET_TEMPLATE_EDIT_FORM,
  SET_TEMPLATE_LIST_VIEW,
  SET_TEMPLATE_OVERLAY_VIEW,
  SET_USER_LIST_VIEW,
  UPDATE_BATCH,
  UPDATE_BIN,
  UPDATE_DIE,
  UPDATE_EOD,
  UPDATE_HORIZON,
  UPDATE_HORIZON_STAT,
  UPDATE_JOB,
  UPDATE_ORDER,
  UPDATE_SCRAP,
  UPDATE_SHIPMENT,
  UPDATE_YELLOWBAG,
  GET_MID_ORDERS,
  GET_YELLOWBAGS,
  SET_COMMENT_SHIPMENT_MAP,
  SET_COMMENT_JOBS_MAP,
  SET_COMMENT_ORDERS_MAP, UPDATE_PRODUCT, GET_AMAZON_ORDERS, GET_ROLES, CREATE_ROLE, DELETE_ROLE, UPDATE_ROLE, SET_ROLE_VIEW, GET_MARKETPLACE_ORDERS, GET_PTO_BATCHES, GET_PTO_PREPRINT_BATCHES,
  GET_PTO_PRINTING_BATCHES,
  GET_PTO_SEALED_PRINTING_BATCHES,
  GET_PTO_ORDERS,
  GET_LASER_PRESTA_MATERIAL_CONFIG,
  UPDATE_LASER_PRESTA_MATERIAL_CONFIG,
  CREATE_LASER_PRESTA_MATERIAL_CONFIG,
  DELETE_LASER_PRESTA_MATERIAL_CONFIG
} from '../../ngrx/actions';

import { 
  AuthenticationService,
  BatchService,
  EODService,
  JobService,
  MQTTService,
  HorizonService,
  OrderService,
  PrinterService,
  ProductService,
  ScrapService,
  SettingService,
  ShipmentService,
  TemplateService,
  RoleService,
  PrestaSubassemblyService
} from '../services';

import {
  BOXED,
  CANCELLED,
  CLOSED,
  COMPLETED,
  EOD_COMPLETED,
  QUEUED,
  LOCKED,
  OPEN,
  SHIPPED,
  SERVICE,
  DELIVERYDATE,
  DUEDATE,
  DAYSUNTILDUE,
  PENDING_PRINTING,
  ONLASER,
  SEALED,
  SHIPMENTS,
  MARKETPLACEEMAILS,
  PREPRINT,
  PRINTING,
  SEALED_PRINTING,
  PTO,
  CUSTOMERDUE
} from '../../ngrx/status-types';

import { OA, RFID, SHEETS } from '../../ngrx/category-types';

import { Bin, Batch, EOD, Horizon, Job, Order, Product, Setting, Shipment, Role } from '../models';

import { TranslateService } from '../i18n';

@Component({
  templateUrl: './online-aisle-layout.component.html',
  styleUrls:   ['./online-aisle-layout.component.scss'],
  providers: [ DaysUntilDuePipe ]
})
export class OnlineAisleLayoutComponent implements OnInit, OnDestroy {
  initSubscriptions: Subscription[];
  initCheck        : Subject<any> = new Subject();
  allowEod         : boolean;
  availableHorizons: Horizon[];
  batchList        : Observable<Batch[]>;
  batchListView    : Observable<any>;
  batchesInit      : boolean;
  binList          : Observable<Bin[]>;
  binsInit         : boolean;
  currentlyDueOrders: Observable<any>;
  diesInit         : boolean;
  eodList          : Observable<EOD[]>;
  eodOAProcessing  : boolean;
  jobList          : Observable<Job[]>;
  jobsInit         : boolean;
  lastEODRanToday  : Observable<boolean>;
  horizon          : any;
  shippingConfig   : any;
  horizonList      : Observable<Horizon[]>;
  language         : { lang: string, url: string };
  loggingOut       : boolean;
  mailInnovationsOrders: Observable<any>;
  nextBusinessDay  : Observable<string>;
  nextBusinessDate       : string;
  networkConnected : boolean = false;
  orderList        : Observable<Order[]>;
  ordersInit       : boolean;
  productsInit     : boolean;
  productList      : Observable<Product[]>;
  progressPercent  : number = 0;
  query            : any;
  queryList        : any[];
  queryListNoMatch : boolean;
  mainView         : Observable<any>;
  dueTodayJobs     : number;
  dueTodayOrders   : Observable<Order[]>;
  lateJobs         : number;
  overdueOrders    : Observable<Order[]>;
  reprintOverdueOrders: Observable<Order[]>;
  rtsJobs          : number;
  RTSOrders        : Observable<Order[]>;
  RTSTotal         : Observable<any>;
  scrapsInit       : boolean;
  shipmentList     : Observable<Shipment[]>;
  shipmentsInit    : boolean;
  systemSettingList: Observable<Setting[]>;
  yellowBagList    : Observable<any>;
  roleList         : Observable<Role[]>;
  rolesInit        : boolean;
  user             : string;
  userRole      : any;
  loading                : boolean;
  getShipment      : Subscription;

  constructor(
    private authService    : AuthenticationService,
    private batchService   : BatchService,
    private eodService     : EODService,
    private jobService     : JobService,
    private horizonService : HorizonService,
    private mqttService    : MQTTService,
    private orderService   : OrderService,
    private printerService : PrinterService,
    private productService : ProductService,
    private router         : Router,
    private scrapService   : ScrapService,
    private settingService : SettingService,
    private shipmentService: ShipmentService,
    private roleService    : RoleService,
    private prestaSubassemblyService: PrestaSubassemblyService,
    private store          : Store<any>,
    private templateService: TemplateService,
    private toasterService : ToasterService,
    private translate      : TranslateService,
    private daysUntilDue   : DaysUntilDuePipe
  ) {
    this.batchList     = this.batchService.getBatchList();
    this.batchListView = this.batchService.getBatchListView();
    this.binList       = this.shipmentService.getBinList();
    this.currentlyDueOrders = this.orderService.getCurrentlyDueOrders();
    this.dueTodayOrders= this.orderService.getDueTodayOrderList();
    this.eodList       = this.eodService.getEODHistoryList();
    this.horizonList   = this.horizonService.getHorizonList();
    this.jobList       = this.jobService.getJobList();
    this.lastEODRanToday = this.eodService.getLastEODRanToday();
    this.mailInnovationsOrders = this.orderService.getMailInnovationsOrders();
    this.orderList     = this.orderService.getOrderList();
    this.overdueOrders = this.orderService.getOverdueOrderList();
    this.productList   = this.productService.getProductList();
    this.reprintOverdueOrders = this.orderService.getReprintOverdueOrderList();
    this.RTSOrders     = this.orderService.getRTSOrderList();
    this.RTSTotal = this.shipmentService.getRTSTotal();
    this.mainView      = this.authService.getMainView();
    this.nextBusinessDay = this.settingService.getNextBusinessDay();
    this.shipmentList  = this.shipmentService.getShipmentList();
    this.systemSettingList = this.settingService.getSettingList();
    this.yellowBagList = this.shipmentService.getYellowBagList();
    this.roleList      = this.roleService.getRoleList();
  }

  ngOnInit(): void {
    this.loading = true;
    const today = moment().format('YYYY-MM-DD');
    const lastWeek = moment(today).subtract(7, 'days');
    const tomorrow = moment(today).add(1, 'days');
    const tomorrowFormatted = tomorrow.format('YYYY-MM-DD');
    const lastWeekFormatted = lastWeek.format('YYYY-MM-DD');

    const lang = localStorage.getItem('language') || 'EN';
    const url  = lang === 'ES' ? 'assets/img/flags/Mexico.png' : 'assets/img/flags/USA.png';

    this.setLang(lang, url);
    this.userRole = this.authService.getUserRole();

    const user = this.authService.getCurrentUser();
    this.user = user.substring(0, user.indexOf('@'));

    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: { 
        horizon: this.horizonService.getHorizonConfig(),
        horizonLoading: true,
        process: OA,
        shippingConfig: this.settingService.getShippingConfig(),
      }
    });

    this.store.dispatch({
      type   : SET_LOGIN_VIEW,
      payload: {
        loading: false,
        message: ''
      }
    });

    this.store.dispatch({
      type   : SET_BATCH_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_BATCH_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_BINS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_EOD_HISTORY_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_DIE_LIST_VIEW,
      payload: { initializing: true }
    });
    this.store.dispatch({
      type   : SET_HOLD_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_JOB_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_JOB_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_ORDER_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_ORDER_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_SHIPMENT_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_SHIPMENT_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_PRODUCT_LIST_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type   : SET_PRODUCT_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.store.dispatch({
      type: SET_SCRAP_REPORT_VIEW,
      payload: { loading: true }
    });

    this.initSubscriptions = [
      this.mainView
        .subscribe((mainViewState: any) => {
          const { 
            dueTodayJobs,
            lateJobs,
            loggingOut, 
            horizon, 
            eodOAProcessing,
            networkConnected,
            shippingConfig 
          } = mainViewState;
          this.eodOAProcessing = eodOAProcessing;
          this.loggingOut      = loggingOut;
          this.dueTodayJobs    = dueTodayJobs;
          this.lateJobs        = lateJobs;
          this.networkConnected = networkConnected;
          this.shippingConfig = shippingConfig;
          
          // if (dataInit && this.horizon !== horizon) {
          //   console.log(`horizon configuration changed from ${this.horizon} to ${horizon}`);
          //   this.store.dispatch({
          //     type: SET_BATCH_DETAILS_VIEW,
          //     payload: { loading: true }
          //   });
          //   this.store.dispatch({
          //     type: SET_BATCH_LIST_VIEW,
          //     payload: { loading: true }
          //   });

          //   if (horizon === 'NONE') {
          //     this.batchService
          //       .getActiveOABatches()
          //       .take(1)
          //       .subscribe(
          //         (value: any) => {
          //           console.log(value);
          //           const { statusCode } = value;

          //           if (statusCode === 200) {
          //             const { activeBatches } = JSON.parse(value.body).data;

          //             if (activeBatches) {
          //               this.store.dispatch({
          //                 type: GET_BATCHES,
          //                 payload: { batches: activeBatches }
          //               });
          //             }
          //           }
          //         }
          //       );
          //   } else {
          //     this.batchService
          //       .getBatchesByHorizonId(horizon)
          //       .take(1)
          //       .subscribe(
          //         (value: any) => {
          //           console.log(value);
          //           const { statusCode } = value;
  
          //           if (statusCode === 200) {
          //             const { batchesByHorizonId } = JSON.parse(value.body).data;
  
          //             if (batchesByHorizonId) {
          //               this.store.dispatch({
          //                 type: GET_BATCHES,
          //                 payload: { batches: batchesByHorizonId }
          //               });
          //             }
          //           }
          //         },
          //         (error: Error) => console.log(error),
          //         () => {
          //           this.store.dispatch({
          //             type: SET_BATCH_DETAILS_VIEW,
          //             payload: { loading: false }
          //           });
          //           this.store.dispatch({
          //             type: SET_BATCH_LIST_VIEW,
          //             payload: { loading: false }
          //           });
          //         }
          //       );
          //   }
          // }

          this.horizon = horizon;
        }),

      Observable
        .combineLatest(
          this.batchList,
          this.horizonList
        )
        .subscribe(([ batches, horizons ]) => {
          batches.forEach(batch=>{
            batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
            if(batch.activity_history[batch.activity_history.length - 1] && batch.activity_history[batch.activity_history.length - 1].activity === OPEN) {
              batch.createdAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
            }
            batch.updatedAt = batch.activity_history.length && batch.activity_history[0].timestamp;
          })

          this.availableHorizons = horizons;
          // console.log("horizons : ", horizons)
          const sortedBatches = [ ...batches ];
          const regularBatches = sortedBatches.filter(batch => batch.batchStatus !== PREPRINT && batch.batchStatus !== SEALED_PRINTING && batch.batchStatus !== PRINTING);
          const horizonSplit = this.groupBy(regularBatches, 'horizon_id');
          const horizonKeys = Object.keys(horizonSplit);

          //Get PTO batches
          const ptoBatches = sortedBatches.filter(batch => batch.compKey.includes('PTO'));
          const ptoPreprintBatches = sortedBatches.filter(batch => batch.batchStatus === PREPRINT);
          // Sort printing list by totalQty descending
          const ptoPrintingBatches = sortedBatches
            .filter(batch => batch.batchStatus === PRINTING)
            .sort((a, b) => {
              const qa = (a && a.totalQty) || 0;
              const qb = (b && b.totalQty) || 0;
              return qb - qa;
            });
          const ptoSealedPrintingBatches = sortedBatches.filter(batch => batch.batchStatus === SEALED_PRINTING);

          this.store.dispatch({
            type   : GET_PTO_BATCHES,
            payload: { ptoBatches: ptoBatches }
          });
          this.store.dispatch({
            type   : GET_PTO_PREPRINT_BATCHES,
            payload: { ptoPreprintBatches: ptoPreprintBatches }
          });
          this.store.dispatch({
            type   : GET_PTO_PRINTING_BATCHES,
            payload: { ptoPrintingBatches: ptoPrintingBatches }
          });
          this.store.dispatch({
            type   : GET_PTO_SEALED_PRINTING_BATCHES,
            payload: { ptoSealedPrintingBatches: ptoSealedPrintingBatches }
          });

          if (!horizonKeys || !horizonKeys.length) {
            this.store.dispatch({
              type   : GET_SORTED_OA_BATCHES,
              payload: { batches: {} }
            });
          } else if (batches.length === 1) {
            this.store.dispatch({
              type   : GET_SORTED_OA_BATCHES,
              payload: { batches: horizonSplit }
            });
          } else {
            horizons.forEach(({ id }) => {
              if (!horizonSplit[id] || !horizonSplit[id].length) {
                horizonSplit[id] = [];
              } else {
                // Separate batches by their processing status
                // const preprintBatches = horizonSplit[id].filter(batch => batch.batchStatus === PREPRINT);
                const openBatches = horizonSplit[id].filter(batch => batch.batchStatus === OPEN);
                const lockedBatches = horizonSplit[id].filter(batch => batch.batchStatus === LOCKED);
                const sealedBatches = horizonSplit[id].filter(batch => batch.batchStatus === SEALED);
                const onLaserBatches = horizonSplit[id].filter(batch => batch.batchStatus === ONLASER);
                const completedBatches = horizonSplit[id].filter(batch => batch.batchStatus === COMPLETED);

                const optimizeBatchOrder = (batchesToOptimize: any[], priorityMaterial?: string) => {
                  if (!batchesToOptimize.length) return [];
                  const sortedBatches = [];

                  // A. HORIZON BATCHES -- WE MUST MINIMIZE AMOUNT OF MATERIAL CHANGES AND DIE CHANGES FOR MAXIMUM EFFICIENCY
                  if (batchesToOptimize[0].finishing_type == 'horizon') {
                    // NEW SORTING APPROACH: Material > Die > Due Date > Quantity
                    // 1. Group all batches by material type first
                    const materialSplit = this.groupBy(batchesToOptimize, 'subAssembly');
                    const materialKeys = Object.keys(materialSplit);
                    const due = [];
                    const dieByMaterial = [];

                    // Prioritize materials that are currently locked in a machine or specified priority
                    if (priorityMaterial) {
                      sort(materialKeys).asc(key => key === priorityMaterial ? -1 : 1);
                    }

                    // For each material, find earliest due date and use that for sorting
                    materialKeys.forEach(material => {
                      sort(materialSplit[material]).asc('dueDate');
                      due.push({
                        material,
                        dueDate: materialSplit[material][0].dueDate
                      });
                    });

                    // Sort materials by earliest due date first
                    sort(due).asc('dueDate');
                    const sortedMaterialKeys = due.map(({ material }) => material);

                    // Group dies within each material for efficient transitions
                    sortedMaterialKeys.forEach((material, i) => {
                      const dieSplit = this.groupBy(materialSplit[material], 'die');
                      const dKeys = Object.keys(dieSplit);

                      // Store dies for each material in our tracking structure
                      if (dieByMaterial[i]) {
                        if (dieByMaterial[i][material]) {
                          dieByMaterial[i][material].push(...dKeys);
                        } else {
                          dieByMaterial[i][material] = dKeys;
                        }
                      } else {
                        dieByMaterial[i] = {};
                        dieByMaterial[i][material] = dKeys;
                      }
                    });

                    // CRITICAL SECTION: Optimize die transitions between materials
                    // This minimizes the need to change both material and die simultaneously
                    let lastKey, intersection;
                    for (let i = 0; i < sortedMaterialKeys.length - 1; i++) {
                      const currentDieKeySet = dieByMaterial[i][sortedMaterialKeys[i]];
                      const nextDieKeySet = dieByMaterial[i + 1][sortedMaterialKeys[i + 1]];
                      // Keep first die in position, only sort secondary dies
                      const keySetToSort = currentDieKeySet.slice(1);

                      if (keySetToSort.length) {
                        // Find dies that exist in both current and next material
                        intersection = this.intersectUnique(keySetToSort, nextDieKeySet);

                        if (!intersection.length) {
                          // No common dies, just use first die
                          lastKey = currentDieKeySet[0];
                        } else {
                          // End current material with a die that's also in next material
                          // This allows changing only the material, not both material and die simultaneously
                          lastKey = intersection[intersection.length - 1];
                          sort(keySetToSort).desc(key => key === lastKey ? -1 : 1);
                        }
                      } else {
                        // Only one die for this material, use it
                        lastKey = currentDieKeySet[0];
                      }

                      // Reassemble the current material's dies with primary die first
                      dieByMaterial[i][sortedMaterialKeys[i]] = [
                        currentDieKeySet[0],
                        ...keySetToSort
                      ];

                      // Sort next material's dies to start with the die we ended with
                      // This completes the optimization by ensuring smooth transitions
                      sort(nextDieKeySet).desc(key => key === lastKey ? 1 : -1);
                    }

                    // Create final batch list by following the optimized hierarchy
                    sortedMaterialKeys.forEach((material, i) => {
                      const dieKeys = dieByMaterial[i][material];
                      dieKeys.forEach(die => {
                        // Find all batches matching current material and die
                        // Handle null die case properly by checking for string "null" from groupBy
                        const relevantBatches = batchesToOptimize.filter(batch =>
                          batch.subAssembly === material &&
                          ((die === "null" && batch.die === null) || (die !== "null" && batch.die === die)) &&
                          batch.horizon_id === id);

                        // For same material and die, sort first by due date, then by quantity
                        // const finalSortedBatch = sort(relevantBatches).asc('totalQty');

                        // Sort by quantity first (secondary sort)
                        const qtySort = sort([...relevantBatches]).asc('totalQty');
                        // Then sort by due date (primary sort) - stable sort preserves quantity ordering for same dates
                        const finalSortedBatch = sort(qtySort).asc('dueDate');

                        // Add to final list, maintaining sort hierarchy
                        sortedBatches.push(...finalSortedBatch);
                      });
                    });
                  } else {
                    // B. LASER CUT BATCHES -- MATERIAL CHANGE CONSIDERATIONS ARE NOT CRITICAL, DUE DATE IS
                    // CUT SORTING APPROACH: DUE DATE > CUSTOM JOBS > MATERIAL

                    // Sort by material first (tertiary sort)
                    const materialSort = sort([...batchesToOptimize]).asc('subAssembly');

                    // Then sort by custom size (secondary sort) - stable sort preserves material ordering
                    // The below one should also work but let's be more direct and use attribute straight from Magento
                    // const customSizeSort = sort(materialSort).desc(batch => !batch.die ? 1 : 0);
                    const customSizeSort = sort(materialSort).desc(batch => batch.isCustomSize ? 1 : 0);

                    // Finally sort by due date (primary sort) - stable sort preserves previous ordering
                    const laserCutBatches = sort(customSizeSort).asc('dueDate');
                    laserCutBatches.forEach(batch => sortedBatches.push(batch))

                  }
                  return sortedBatches;

                };

                // Get priority material from locked batches if available
                const priorityMaterial = lockedBatches.length ? lockedBatches[0].subAssembly : null;

                // Optimize both open and sealed batches
                const optimizedOpenBatches = optimizeBatchOrder(openBatches, priorityMaterial);
                const optimizedSealedBatches = optimizeBatchOrder(sealedBatches, priorityMaterial);

                // Assemble final batch list by status priority (highest to lowest)
                // This ensures batches with special status are processed first
                // console.log("completedBatches", completedBatches);
                // console.log("lockedBatches", lockedBatches);
                console.log("sealedBatches length", sealedBatches.length)
                console.log("optimizedSealedBatches length", optimizedSealedBatches.length);
                console.log("sealedBatches", sealedBatches)
                console.log("optimizedSealedBatches", optimizedSealedBatches);
                // console.log("onLaserBatches", onLaserBatches);
                // console.log("optimizedOpenBatches", optimizedOpenBatches);
                const finalBatches = [
                  ...completedBatches,
                  ...lockedBatches,
                  ...optimizedSealedBatches,
                  ...onLaserBatches,
                  ...optimizedOpenBatches
                ];

                horizonSplit[id] = finalBatches;
              }
            });

            console.log(`batches split by horizon`);
            console.log(horizonSplit);

            this.store.dispatch({
              type   : GET_SORTED_OA_BATCHES,
              payload: { batches: horizonSplit }
            });
          }
        }),

        this.mqttService
        .productListener
        .subscribe(({ payload }) => { 
          console.log(payload)
        }),

      this.mqttService
        .batchListener
        .subscribe(({ payload }) => {
          const { type, id, category, body, diffList } = payload;
          // console.log("BATCH UPDATE: ",payload);
          switch (type) {
            case CREATE_BATCH: 
              console.log(`CREATE BATCH RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if(body){
                  let batch = body.data.batch;
                  batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                  if(batch.activity_history[batch.activity_history.length - 1] && batch.activity_history[batch.activity_history.length - 1].activity === OPEN) {
                    batch.createdAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
                  }
                  batch.updatedAt = batch.activity_history.length && batch.activity_history[0].timestamp;  
                  this.store.dispatch({
                    type   : CREATE_BATCH,
                    payload: { batch }
                  }); 
                  console.log(`MQTT: Batch ${batch.id} created!`);
                } else{
                  this.batchService
                    .getBatch(id)
                    .take(1)
                    .subscribe(
                      (value: any) => {
                        const { statusCode } = value;

                        if (statusCode === 200) {
                          const { batch } = JSON.parse(value.body).data;
                          batch.activity_history = batch.activity_history && batch.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
                          if(batch.activity_history[0] && batch.activity_history[0].activity === OPEN) {
                            batch.createdAt = batch.activity_history[0].timestamp;
                            batch.updatedAt = batch.activity_history[batch.activity_history.length - 1].timestamp;
                          }
                          if (batch) {
                            this.store.dispatch({
                              type   : CREATE_BATCH,
                              payload: { batch }
                            });

                            console.log(`MQTT: Batch ${batch.id} created!`);
                          }
                        }
                      },
                      (error: Error) => console.log(error)
                    )
                }
              }
              break;
            case DELETE_BATCH: 
              console.log(`DELETE BATCH RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if (this.router.url.match(new RegExp(`/oa/dashboard/batches/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type: SET_BATCH_DETAILS_VIEW,
                    payload: { loading: true }
                  });
                  this.store.dispatch({
                    type   : DELETE_BATCH,
                    payload: { id }
                  });

                  this.router.navigate(['oa/dashboard/batches/all']);

                  this.store.dispatch({
                    type: SET_BATCH_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_BATCH,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Batch ${id} deleted!`);
              }
              break;
            case UPDATE_BATCH: 
              console.log(`UPDATE BATCH RESPONSE`);
              console.log(payload);
              let batchStatus = null, designatedScrap = null;
              
              if (diffList) {
                const [ status ] = diffList.filter(({ path, diff, newVal }) => {
                  return path && path === 'batchStatus' && diff && diff === 'updated' && newVal;
                });

                const [ dScrap ] = diffList.filter(({ path, diff, newVal }) => {
                  return path && path === 'designatedScrap' && diff && diff === 'updated' && newVal;
                });
                
                batchStatus = (status && status.newVal) || '';
                designatedScrap = (dScrap && dScrap.newVal) || false;
              }

              if (id && category === OA && batchStatus != null) {
                if (batchStatus === CLOSED || designatedScrap) {
                  if (this.router.url.match(new RegExp(`/oa/dashboard/batches/\\w+/${id}`, 'i'))) {
                    this.store.dispatch({
                      type   : DELETE_BATCH,
                      payload: { id }
                    });
                    
                    this.router.navigate(['oa/dashboard/batches/all']);

                    this.store.dispatch({
                      type: SET_BATCH_DETAILS_VIEW,
                      payload: { loading: false }
                    });
                  } else {
                    this.store.dispatch({
                      type   : DELETE_BATCH,
                      payload: { id }
                    });
                  }
                } else {
                  this.store.dispatch({
                    type   : SET_BATCH_LIST_VIEW,
                    payload: { scrapLoading: false, switchingBatch: false }
                  });

                  if (this.router.url.match(new RegExp(`/oa/dashboard/batches/\\w+/${id}`, 'i'))) {
                    this.store.dispatch({
                      type: SET_BATCH_DETAILS_VIEW,
                      payload: { loading: true }
                    });

                    this.store.dispatch({
                      type   : UPDATE_BATCH,
                      payload: { id, diffList }
                    });

                    this.store.dispatch({
                      type: SET_BATCH_DETAILS_VIEW,
                      payload: { loading: false }
                    });
                  } else {
                    this.store.dispatch({
                      type   : UPDATE_BATCH,
                      payload: { id, diffList }
                    });
                  }
                  console.log(`MQTT: Batch ${id} updated!`);                  
                }
                                                             
              }
              break;
          }
        }),

      this.mqttService
        .binListener
        .subscribe(({ payload }) => {
          const { type, id, category, body } = payload;

          switch (type) {
            case UPDATE_BIN: 
            console.log(`UPDATE BIN RESPONSE`);
            console.log(payload);
            if (id && category === OA && body) {
              const { diffList } = body;

              this.store.dispatch({
                type   : UPDATE_BIN,
                payload: { id, diffList }
              });
              
              console.log(`MQTT: Bin ${id} updated!`);
            }
              break;
          }
        }),

      this.mqttService
        .dieListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;
          
          switch (type) {
            case CREATE_DIE:
              console.log(`CREATE DIE RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.horizonService
                  .getDie(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { die } = JSON.parse(value.body).data;

                        if (die) {
                          this.store.dispatch({
                            type: CREATE_DIE,
                            payload: { die }
                          });

                          console.log(`MQTT: Die ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
            case DELETE_DIE:
              console.log(`DELETE DIE RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type: DELETE_DIE,
                  payload: { id }
                });

                console.log(`MQTT: Die ${id} deleted!`);
              }
              break;
            case UPDATE_DIE:
              console.log(`UPDATE DIE RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type: SET_BATCH_LIST_VIEW,
                  payload: { diePressureUpdating: true }
                });

                this.horizonService
                  .getDie(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { die } = JSON.parse(value.body).data;

                        if (die) {
                          this.store.dispatch({
                            type: UPDATE_DIE,
                            payload: { die }
                          });

                          console.log(`MQTT: Die ${id} updated`);
                        }
                      }
                    },
                    (error: Error) => {
                      this.store.dispatch({
                        type: SET_BATCH_LIST_VIEW,
                        payload: { diePressureUpdating: false }
                      });
                      this.store.dispatch({
                        type: SET_DIE_LIST_VIEW,
                        payload: { loading: false }
                      });
                      console.log(error);
                    },
                    () => {
                      this.store.dispatch({
                        type: SET_BATCH_LIST_VIEW,
                        payload: { diePressureUpdating: false }
                      });
                      this.store.dispatch({
                        type: SET_DIE_LIST_VIEW,
                        payload: { loading: false }
                      });
                    }
                  )
              }
              break;
          }
        }),

      this.mqttService
        .eodListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_EOD: 
              console.log(`CREATE EOD RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.eodService
                  .getEOD(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { eod } = JSON.parse(value.body).data;

                        if (eod) {
                          this.store.dispatch({
                            type   : CREATE_EOD,
                            payload: { eod }
                          });

                          console.log(`MQTT: EOD ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  )
              }
              break;
            case DELETE_EOD: 
              console.log(`DELETE EOD RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type   : DELETE_EOD,
                  payload: { id }
                });

                console.log(`MQTT: EOD ${id} deleted!`);
              }
              break;
            case UPDATE_EOD: 
              console.log(`UPDATE EOD RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.eodService
                  .getEOD(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { eod } = JSON.parse(value.body).data;

                        if (eod) {
                          this.store.dispatch({
                            type   : UPDATE_EOD,
                            payload: { eod }
                          });

                          console.log(`MQTT: EOD ${id} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  )
              }
              break;
          }
        }),

      this.mqttService
        .horizonListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_HORIZON:
              console.log(`CREATE HORIZON RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.horizonService
                  .getHorizon(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { horizon } = JSON.parse(value.body).data;

                        if (horizon) {
                          this.store.dispatch({
                            type: CREATE_HORIZON,
                            payload: { horizon }
                          });

                          console.log(`MQTT: Horizon ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    () => {}
                  );
              }
              break;
            case DELETE_HORIZON:
              console.log(`DELETE HORIZON RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type: DELETE_HORIZON,
                  payload: { id }
                });

                console.log(`MQTT: Horizon ${id} deleted!`);
              }
              break;
            case UPDATE_HORIZON:
              console.log(`UPDATE HORIZON RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.horizonService
                  .getAllHorizons()
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { horizons } = JSON.parse(value.body).data;
                        console.log("update horizon : ",horizons)
                        if (horizons) {
                          this.store.dispatch({
                            type: GET_HORIZONS,
                            payload: { horizons }
                          });

                          console.log(`MQTT: Horizon ${id} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    () => {}
                  );
              }
              break;
          }
        }),

      this.mqttService
        .roleListener
        .subscribe(({ payload }) => {
          // console.log("roles mqtt: ", payload)
          const { type, code, category, body } = payload;

          switch (type) {
            case UPDATE_ROLE: 
            console.log(`UPDATE ROLE RESPONSE`);
            console.log(payload);
            if (code && category === OA) {
              this.roleService
                  .getAll()
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { roles } = JSON.parse(value.body).data;
                        console.log("update roles : ", roles)
                        if (roles) {
                          this.store.dispatch({
                            type: GET_ROLES,
                            payload: { roles }
                          });

                          console.log(`MQTT: Role ${code} updated!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    () => {}
                  );
            }
              break;
          }
        }),

      this.mqttService
        .horizonStatListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_HORIZON_STAT:
              console.log(`CREATE HORIZON STAT RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.horizonService
                  .getHorizonStat(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;
                      
                      if (statusCode === 200) {
                        const { horizonStat } = JSON.parse(value.body).data;

                        if (horizonStat) {
                          this.store.dispatch({
                            type: CREATE_HORIZON_STAT,
                            payload: { horizonStat }
                          });

                          console.log(`MQTT: Horizon Stat ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    () => {}
                  );
              }
              break;
            case DELETE_HORIZON_STAT:
              console.log(`DELETE HORIZON STAT RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type: DELETE_HORIZON_STAT,
                  payload: { id }
                });
              }
              break;
            case UPDATE_HORIZON_STAT:
              console.log(`UPDATE HORIZON STAT RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.horizonService
                  .getHorizonStat(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;
                      
                      if (statusCode === 200) {
                        const { horizonStat } = JSON.parse(value.body).data;

                        if (horizonStat) {
                          this.store.dispatch({
                            type: UPDATE_HORIZON_STAT,
                            payload: { horizonStat }
                          });

                          console.log(`MQTT: Horizon Stat ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error),
                    () => {}
                  );
              }
              break;
          }
        }),

      this.mqttService
        .jobListener
        .subscribe(({ payload }) => {
          const { type, id, category, body, diffList, makeToStock } = payload;

          switch (type) {
            case CREATE_JOB: 
              console.log(`CREATE JOB RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if(body){
                  const job = body.data.job;
                  this.store.dispatch({
                    type   : CREATE_JOB,
                    payload: { job }
                  });
                  console.log(`MQTT: Job ${id} created!`);
                } else {
                  this.jobService
                    .getJob(id)
                    .take(1)
                    .subscribe(
                      (value: any) => {
                        console.log(value);
                        const { statusCode } = value;

                        if (statusCode === 200) {
                          const { job } = JSON.parse(value.body).data;

                          if (job) {
                            this.store.dispatch({
                              type   : CREATE_JOB,
                              payload: { job }
                            });

                            console.log(`MQTT: Job ${id} created!`);
                          }
                        }
                      },
                      (error: Error) => console.log(error)
                    );
                }
              }
              break;
            case DELETE_JOB: 
              console.log(`DELETE JOB RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if (this.router.url.match(new RegExp(`/oa/dashboard/jobs/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: true }
                  });

                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });

                  this.router.navigate(['oa/dashboard/jobs/all']);
                    
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Job ${id} deleted!`);
              }
              break;
            case UPDATE_JOB: 
              if (id && category === OA) {
                console.log(`UPDATE JOB RESPONSE`);
                console.log(payload);

                let jobStatus = null, oldJobStatus = null;

                if (diffList) {
                  const [ status ] = diffList.filter(({ path, diff, newVal }) => {
                    return path && path === 'jobStatus' && diff && diff === 'updated' && newVal;
                  });

                  jobStatus = (status && status.newVal) || '';
                  oldJobStatus = (status && status.oldVal) || '';

                  console.log(`old job status: ${oldJobStatus}`);
                  console.log(`new job status: ${jobStatus}`);
                }

                if (jobStatus && (jobStatus === EOD_COMPLETED || jobStatus === CANCELLED)) {
                  this.store.dispatch({
                    type   : DELETE_JOB,
                    payload: { id }
                  });
                  if (this.router.url.match(new RegExp(`/dashboard/jobs/\\w+/${id}`, 'i'))) {
                    this.router.navigate(['dashboard/jobs/all']);
                  }
                } else {
                  if(diffList){
                    this.store.dispatch({
                      type   : UPDATE_JOB,
                      payload: { id, diffList }
                    });
                    console.log(`MQTT: Job ${id} updated!`);
                  }
                }

                if (makeToStock && oldJobStatus === QUEUED && jobStatus !== QUEUED) {
                  console.log(`Work order has been printed for MTS OA Job ${id}`);
                  this.store.dispatch({
                    type: DELETE_QUEUED_MTS_JOB,
                    payload: { id }
                  });

                  this.store.dispatch({
                    type: SET_BATCH_LIST_VIEW,
                    payload: { mtsWorkOrdersPrinting: false }
                  });
                }

                this.store.dispatch({
                  type: SET_JOB_DETAILS_VIEW,
                  payload: { loading: false }
                });
              }
              break;
              
          }
        }),

      this.mqttService
        .orderListener
        .subscribe(({ payload }) => {
          const { type, id, category } = payload;

          switch (type) {
            case CREATE_ORDER: 
              console.log(`CREATE ORDER RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.orderService
                  .getOrder(id)
                  .take(1)
                  .subscribe(
                    (value: any) => {
                      console.log(value);
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { order } = JSON.parse(value.body).data;

                        if (order) {
                          this.store.dispatch({
                            type   : CREATE_ORDER,
                            payload: { order }
                          });

                          console.log(`MQTT: Order ${id} created!`);
                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
            case DELETE_ORDER: 
              console.log(`DELETE ORDER RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if (this.router.url.match(new RegExp(`/oa/dashboard/orders/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: true }
                  });

                  this.store.dispatch({
                    type   : DELETE_ORDER,
                    payload: { id }
                  });

                    
                  this.router.navigate(['oa/dashboard/orders/all']);

                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_ORDER,
                    payload: { id }
                  });
                }
              }
              break;
            case UPDATE_ORDER: 
              console.log(`UPDATE ORDER RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                Observable
                  .combineLatest(
                    this.orderService.getOrder(id),
                    this.orderList,
                    this.jobList,
                    this.shipmentList
                  )
                  .take(1)
                  .subscribe(
                    ([ value, orders, jobList, shipments ]) => {
                      const { statusCode } = value;

                      if (statusCode === 200) {
                        const { order } = JSON.parse(value.body).data;

                        if (order) {
                          if (this.router.url.match(new RegExp(`/oa/dashboard/orders/\\w+/${id}`, 'i'))) {
                            if (order.status === EOD_COMPLETED || order.status === CANCELLED) {
                              this.store.dispatch({
                                type   : DELETE_ORDER,
                                payload: { id: order.id }
                              });

                              this.router.navigate(['oa/dashboard/orders/all']);
  
                              if (order.status === CANCELLED && orders.find(o => o.id === order.id)) {
                                this.toasterService.clear();
                                this.toasterService.pop({
                                  type   : 'success',
                                  title  : this.translate.instant('ORDER_CANCELLED_HEADER'),
                                  body   : this.translate.instant('ORDER_CANCELLED_INFO', [order.id.startsWith('OA') ? order.id.substring(2) : order.id]),
                                  timeout: 8000
                                });

                                console.log(`MQTT: Order ${id} cancelled!`);
                              }
                            } else {
                              this.store.dispatch({
                                type   : UPDATE_ORDER,
                                payload: { order }
                              });

                              console.log(`MQTT: Order ${id} updated!`);
                            }

                            this.store.dispatch({
                              type   : SET_ORDER_DETAILS_VIEW,
                              payload: { loading: false }
                            });
                          } else {
                            if (order.status === EOD_COMPLETED || order.status === CANCELLED) {
                              this.store.dispatch({
                                type   : DELETE_ORDER,
                                payload: { id: order.id }
                              });
  
                              if (order.status === CANCELLED) {
                                this.toasterService.clear();
                                this.toasterService.pop({
                                  type   : 'success',
                                  title  : this.translate.instant('ORDER_CANCELLED_HEADER'),
                                  body   : this.translate.instant('ORDER_CANCELLED_INFO', [order.id.startsWith('OA') ? order.id.substring(2) : order.id]),
                                  timeout: 8000
                                });

                                console.log(`MQTT: Order ${id} cancelled!`);
                              }
                            } else {
                              this.store.dispatch({
                                type   : UPDATE_ORDER,
                                payload: { order }
                              });

                              console.log(`MQTT: Order ${id} updated!`);
                            }
                          }

                          console.log(`order`);
                          console.log(order);
                          let allJobsReady = true;
                          // console.log('alljobsReady : ',allJobsReady)
                          order.jobs.length && order.jobs.forEach(jobs => {
                            let job = jobList.find(o => o.id === jobs);
                            // console.log('jobId : ' + jobs + ' | job = ', job)
                            // console.log('jobStatus = ', job.status);
                            if(job && job.status !== SHIPMENTS) {
                              allJobsReady = false;
                            }
                          })
                          console.log(`all jobs ready in shipment: ${allJobsReady}`);

                          if (allJobsReady) {
                            // print packing slip for the shipment here
                            const orderShipment = shipments.find(shipment => shipment.orderId === order.id);
                            // console.log(`All jobs for order ${order.id} are ready!`);
                            if (orderShipment && orderShipment.bin !== null && orderShipment.activity_history[0].activity !== 'qa Ok'
                                && (order.activity_history[0].activity=== SHIPMENTS && order.activity_history[0].user === user)) {
                              const body = `
                                <div>${this.translate.instant('NEW_SHIPMENT_CREATED_INFO6')} 
                                  #<strong>${orderShipment.orderId}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO9')}
                                  <div class='bin-number'>
                                  Bin #<strong>${orderShipment.bin}</strong>
                                  </div> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO8')}.
                                </div>`;
                              this.shipmentService.displayShipmentDetails.next({
                                class: 'bg-success',
                                title: this.translate.instant('NEW_SHIPMENT_FINISHED'),
                                body
                              });
                            }

                          }



                        }
                      }
                    },
                    (error: Error) => console.log(error)
                  );
              }
              break;
          }
        }),

      this.mqttService
        .scrapListener
        .subscribe(({ payload }) => {
          const { type, id, category, diffList, scrap } = payload;

          switch (type) {
            case CREATE_SCRAP: 
              console.log(`CREATE SCRAP RESPONSE`);
              console.log(payload);
              if (id && category === OA && scrap) {
                this.store.dispatch({
                  type: CREATE_SCRAP,
                  payload: { scrap }
                });

                console.log(`MQTT: Scrap ${id} created!`);
              }
              break;
            case DELETE_SCRAP: 
              console.log(`DELETE SCRAP RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                this.store.dispatch({
                  type   : DELETE_SCRAP,
                  payload: { id }
                });

                console.log(`MQTT: Scrap ${id} deleted!`);
              }
              break;
            case UPDATE_SCRAP: 
              console.log(`UPDATE SCRAP RESPONSE`);
              console.log(payload);
              if (id && category === OA && diffList) {
                this.store.dispatch({
                  type: UPDATE_SCRAP,
                  payload: { id, diffList }
                });

                console.log(`MQTT: Scrap ${id} updated!`);
              }
              break;
          }
        }),

      this.mqttService
        .shipmentListener
        .subscribe(({ payload }) => {
          const { type, id, category, body } = payload;
          switch (type) {
            case CREATE_SHIPMENT: 
              console.log(`CREATE SHIPMENT RESPONSE`);
              console.log(payload);
              if (id && category === OA && body) {
                const { shipment } = body;

                this.store.dispatch({
                  type: CREATE_SHIPMENT,
                  payload: { shipment }
                });

                const user = this.authService.getCurrentUser();

                if (shipment && shipment.createdBy === user ) {
                  let body,title = '';
                  if(shipment.jobs.length > 1) {
                    body = `
                      <div>
                        ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO3')} 
                        <strong>${shipment.orderId}</strong>
                        ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO2')} 
                        <div class='bin-number'>
                        Bin #<strong>${shipment.bin}</strong>
                        </div>
                      </div>
                    `;
                    title = this.translate.instant('NEW_SHIPMENT_CREATED')
                  } else {
                    body = `
                      <div>${this.translate.instant('NEW_SHIPMENT_CREATED_INFO6')}  
                        #<strong>${shipment.orderId}</strong> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO9')}
                        <div class='bin-number'>
                        Bin #<strong>${shipment.bin}</strong>
                        </div> ${this.translate.instant('NEW_SHIPMENT_CREATED_INFO8')}.
                      </div>
                    `;
                    title = this.translate.instant('NEW_SHIPMENT_FINISHED')
                  }
                  this.shipmentService.displayShipmentDetails.next({
                    class: 'bg-success',
                    title,
                    body
                  });
                } 

                console.log(`MQTT: Shipment ${shipment.id} created!`);
              }
              break;
            case DELETE_SHIPMENT: 
              console.log(`DELETE SHIPMENT RESPONSE`);
              console.log(payload);
              if (id && category === OA) {
                if (this.router.url.match(new RegExp(`/oa/dashboard/shipping/\\w+/${id}`, 'i'))) {
                  this.store.dispatch({
                    type   : DELETE_SHIPMENT,
                    payload: { id }
                  });

                  this.router.navigate(['oa/dashboard/shipping/all']);

                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  this.store.dispatch({
                    type   : DELETE_SHIPMENT,
                    payload: { id }
                  });
                }

                console.log(`MQTT: Shipment ${id} deleted!`);
              }
              break;
            case UPDATE_SHIPMENT: 
              if (id && category === OA && body) {
                console.log(`UPDATE SHIPMENT RESPONSE`);
                console.log(payload);

                const { orderId, shippedBy, diffList, carrier } = body;

                let intlInvoice, packages, shipmentStatus, trackingNumber;

                const formattedOrderID = orderId.startsWith('OA') 
                  ? orderId.substring(2)
                  : orderId;

                diffList.forEach(entry => {
                  const { path, diff } = entry;

                  if (path && diff && diff === 'updated') {
                    if (path === 'intlInvoice') {
                      intlInvoice = entry;
                    } else if (path === 'packages') {
                      packages = entry;
                    } else if (path === 'shipmentStatus') {
                      shipmentStatus = entry;
                    } else if (path === 'trackingNumberUSPS' || path === 'trackingNumberUPS' || path === 'trackingNumberFEDEX') {
                      trackingNumber = entry;
                    }
                  }
                });

                const user = this.authService.getCurrentUser();

                if (this.router.url.match(new RegExp(`/oa/dashboard/shipping/\\w+/${id}`, 'i'))) {
                  if (shipmentStatus && (shipmentStatus.newVal === EOD_COMPLETED || shipmentStatus.newVal === CANCELLED)) {
                    this.store.dispatch({
                      type: DELETE_SHIPMENT,
                      payload: { id }
                    });

                    this.router.navigate(['oa/dashboard/shipping/all']);
                  } else {
                    // Print & Ship label printing trigger
                    if (trackingNumber && !trackingNumber.oldVal && trackingNumber.newVal && shippedBy === user) {
                      console.log(`Print & Ship label printing trigger`);
                      packages && packages.newVal.forEach(pkg => {
                        if (pkg.shippingLabel) {
                          this.printerService.printZPL(pkg.shippingLabel, pkg.trackingNumber, carrier);
                        }
                      });
                      this.shipmentService.printInvoice.next({ printInv: true });
                    }
                    
                    if (intlInvoice && !intlInvoice.oldVal && intlInvoice.newVal && shippedBy === user) {
                      console.log(`intl invoice print trigger`);
                      this.shipmentService.getShipment(id).subscribe(data => {
                        let shipment = JSON.parse(data.body).data.shipment;
                        if(shipment && (shipment.address.country_id == 'VI' || shipment.address.region == 'VI')) {
                          this.printerService.printIntlInvoice(intlInvoice.newVal, formattedOrderID);
                          this.shipmentService.openIntlInvoiceModal.next({ intlInvoice : intlInvoice.newVal, orderId: formattedOrderID });
                        }
                      });
                    }

                    if (shipmentStatus && shipmentStatus.oldVal === SHIPPED && shipmentStatus.newVal === BOXED) {
                      console.log(`shipment reverted trigger`);
                      if (!trackingNumber || !trackingNumber.oldVal) {
                        this.toasterService.pop({
                          type   : 'error',
                          title  : this.translate.instant('SHIPMENT_LABEL_ERROR'),
                          body   : this.translate.instant('SHIPMENT_LABEL_ERROR_INFO', [formattedOrderID]),
                          timeout: 8000
                        });
                      } else {
                        this.toasterService.pop({
                          type   : 'success',
                          title  : this.translate.instant('SHIPMENT_VOID_SUCCESS'),
                          body   : this.translate.instant('SHIPMENT_VOID_SUCCESS_INFO', [formattedOrderID]),
                          timeout: 8000
                        });
                      }
                    }

                    this.store.dispatch({
                      type   : UPDATE_SHIPMENT,
                      payload: { id, diffList }
                    });
                  }

                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                } else {
                  if (shipmentStatus === EOD_COMPLETED) {
                    this.store.dispatch({
                      type   : DELETE_SHIPMENT,
                      payload: { id }
                    });
                  } else {
                    this.store.dispatch({
                      type   : UPDATE_SHIPMENT,
                      payload: { id, diffList }
                    });
                  }
                }

                console.log(`MQTT: Shipment ${id} updated!`);
              }
              break;
          }
        }),

      this.mqttService
        .yellowBagListener
        .subscribe(({ payload }) => {
          const { type, id, category, body } = payload;

          switch (type) {
            case CREATE_YELLOWBAG: 
              console.log(`CREATE YELLOWBAG RESPONSE`);
              console.log(payload);

              if (id && category === OA) {
                const { yellowBag } = body;

                this.store.dispatch({
                  type: CREATE_YELLOWBAG,
                  payload: { yellowBag }
                });

                this.store.dispatch({
                  type   : SET_SHIPMENT_LIST_VIEW,
                  payload: { yellowBagsLoading: false }
                });

                console.log(`MQTT: Yellow Bag ${id} created!`);
              }
              break;
            case DELETE_YELLOWBAG: 
              console.log(`DELETE YELLOWBAG RESPONSE`);
              console.log(payload);
              
              if (id && category === OA) {
                this.store.dispatch({
                  type   : DELETE_YELLOWBAG,
                  payload: { id }
                });
                this.store.dispatch({
                  type   : SET_SHIPMENT_LIST_VIEW,
                  payload: { yellowBagsLoading: false }
                });
              }
              break;
            case UPDATE_YELLOWBAG: 
              console.log(`UPDATE YELLOWBAG RESPONSE`);
              console.log(payload);

              if (id && category === OA && body) {
                const { diffList } = body;

                let yellowBagStatus, shippingLabel, trackingNumber;

                diffList.forEach(entry => {
                  const { path, diff } = entry;

                  if (path && diff && diff === 'updated') {
                    if (path === 'yellowBagStatus') {
                      yellowBagStatus = entry;
                    } else if (path === 'shippingLabel') {
                      shippingLabel = entry;
                    } else if (path === 'trackingNumber') {
                      trackingNumber = entry;
                    }
                  }
                });

                if (shippingLabel && shippingLabel.newVal && trackingNumber && trackingNumber.newVal) {
                  this.printerService.printZPL(shippingLabel.newVal, trackingNumber.newVal);
                }

                if (yellowBagStatus && yellowBagStatus.newVal === EOD_COMPLETED) {
                  this.store.dispatch({
                    type: DELETE_YELLOWBAG,
                    payload: { id }
                  });
                } else {
                  this.store.dispatch({
                    type: UPDATE_YELLOWBAG,
                    payload: { id, diffList }
                  });
                }
                
                console.log(`MQTT: Yellow Bag ${id} updated!`);

                this.store.dispatch({
                  type   : SET_SHIPMENT_LIST_VIEW,
                  payload: { yellowBagsLoading: false }
                });
              }
              break;
          }
        }),
    
      this.mqttService
        .prestaSubassemblyConfigListener
        .subscribe(({ payload }) => {
            const { type, id, body, diffList, prestaSubassemblyConfig } = payload;

            switch (type) {
              case CREATE_LASER_PRESTA_MATERIAL_CONFIG:
                console.log(`CREATE PRESTA SUBASSEMBLY CONFIG RESPONSE`);
                console.log(payload);
                if(prestaSubassemblyConfig){
                  this.store.dispatch({
                    type: CREATE_LASER_PRESTA_MATERIAL_CONFIG,
                    payload: { prestaSubassemblyConfig }
                  });
                }
                break;  
              case UPDATE_LASER_PRESTA_MATERIAL_CONFIG:
                console.log(`UPDATE PRESTA SUBASSEMBLY CONFIG RESPONSE`);
                console.log(payload);
                if (id) {
                  this.store.dispatch({
                    type: UPDATE_LASER_PRESTA_MATERIAL_CONFIG,
                    payload: { id, diffList }
                  });
                }  
                break;
              case DELETE_LASER_PRESTA_MATERIAL_CONFIG:
                console.log(`DELETE PRESTA SUBASSEMBLY CONFIG RESPONSE`);
                console.log(payload);
                if (id) {
                  this.store.dispatch({
                    type: DELETE_LASER_PRESTA_MATERIAL_CONFIG,
                    payload: { id }
                  });
  
                  console.log(`MQTT: Laser Presta Material Config ${id} deleted!`);
                }
                break;
            }
          }),

      this.initCheck
        .subscribe((init: any) => {
          const {
            batches,
            bins,
            dies,
            jobs,
            orders,
            products,
            scraps,
            shipments,
            roles
          } = init;

          if (bins) this.binsInit           = true;
          if (batches) this.batchesInit     = true;
          if (dies) this.diesInit           = true;
          if (jobs) this.jobsInit           = true;
          if (orders) this.ordersInit       = true;
          if (products) this.productsInit   = true;
          if (scraps) this.scrapsInit       = true;
          if (shipments) this.shipmentsInit = true;
          if (roles) this.rolesInit         = true;

          if (this.binsInit && this.batchesInit && this.jobsInit && this.ordersInit && this.productsInit && this.scrapsInit && this.shipmentsInit && this.rolesInit) {
            this.mainView
              .take(1)
              .subscribe(({ dataInit }) => {
                if (!dataInit) {
                  this.store.dispatch({ type: DATA_INIT });
                  this.loading = dataInit;
                  // console.log("dataInit: ",dataInit)
                  this.store.dispatch({
                    type: SET_MAIN_VIEW,
                    payload: { horizonLoading: false }
                  });
                  this.store.dispatch({
                    type   : SET_BATCH_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_BATCH_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_BINS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_EOD_HISTORY_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_DIE_LIST_VIEW,
                    payload: { initializing: false }
                  });
                  this.store.dispatch({
                    type   : SET_HOLD_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_JOB_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_JOB_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_ORDER_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_ORDER_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_SHIPMENT_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_SHIPMENT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_PRODUCT_LIST_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type   : SET_PRODUCT_DETAILS_VIEW,
                    payload: { loading: false }
                  });
                  this.store.dispatch({
                    type: SET_SCRAP_REPORT_VIEW,
                    payload: { loading: false }  
                  });
                  this.store.dispatch({
                    type: SET_ROLE_VIEW,
                    payload: { loading: false }  
                  });
                }
              });
          }
        }),

      this.batchService
        .getAllOA()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_BATCHES,
                payload: { batches: [] }
              });
              this.store.dispatch({
                type   : GET_SUBASSEMBLIES,
                payload: { productSubAssemblies: [] }
              });
            } else {
              const { activeBatches: batches, productSubAssemblies } = JSON.parse(value.body).data;

              console.log(`batches`);
              console.log(batches);
              console.log(`subassemblies`);
              console.log(productSubAssemblies);

              this.store.dispatch({
                type   : GET_BATCHES,
                payload: { batches }
              });
              this.store.dispatch({
                type   : GET_SUBASSEMBLIES,
                payload: { productSubAssemblies }
              });

            }

            this.initCheck.next({ batches: true, subAssemblies: true });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_BATCHES,
              payload: { batches: [] }
            });
            this.store.dispatch({
              type   : GET_SUBASSEMBLIES,
              payload: { productSubAssemblies: [] }
            });

            this.initCheck.next({ batches: true, subAssemblies: true });
          }
        ),

      this.horizonService
        .getAll()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type: GET_DIES,
                payload: { dies: [] }
              });
              this.store.dispatch({
                type: GET_HORIZONS,
                payload: { horizons: [] }
              });
              this.store.dispatch({
                type: GET_HORIZON_STATS,
                payload: { horizonStats: [] }
              });
            } else {
              const { dies, horizons, horizonStats } = JSON.parse(value.body).data;

              console.log(`dies`);
              console.log(dies);
              console.log(`horizons`);
              console.log(horizons);
              console.log(`horizon stats`);
              console.log(horizonStats);

              this.store.dispatch({
                type: GET_DIES,
                payload: { dies }
              });
              this.store.dispatch({
                type: GET_HORIZONS,
                payload: { horizons }
              });
              this.store.dispatch({
                type: GET_HORIZON_STATS,
                payload: { horizonStats: [] }
              });

              this.initCheck.next({ dies: true });
            }
          },
          (error: Error) => {
            console.log(error);

            this.store.dispatch({
              type: GET_DIES,
              payload: { dies: [] }
            });
            this.store.dispatch({
              type: GET_HORIZONS,
              payload: { horizons: [] }
            });
            this.store.dispatch({
              type: GET_HORIZON_STATS,
              payload: { horizonStats: [] }
            });

            this.initCheck.next({ dies: true });
          }
        ),

      this.roleService
        .getAll()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type: GET_ROLES,
                payload: { roles: [] }
              });
            } else {
              const { roles } = JSON.parse(value.body).data;

              console.log(`roles`);
              console.log(roles);

              this.store.dispatch({
                type: GET_ROLES,
                payload: { roles }
              });

              this.initCheck.next({ roles: true });
            }
          },
          (error: Error) => {
            console.log(error);

            this.store.dispatch({
              type: GET_ROLES,
              payload: { dies: [] }
            });

            this.initCheck.next({ dies: true });
          }
        ),

      this.eodService
        .getEODHistoryRange(
          OA, 
          lastWeekFormatted, 
          tomorrowFormatted
        )
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_EOD_HISTORY,
                payload: { eodHistory: [] }
              });
            } else {
              const { eodHistoryRange: eodHistory } = JSON.parse(value.body).data;
              console.log(`eod history`);
              console.log(eodHistory);

              this.store.dispatch({
                type   : GET_EOD_HISTORY,
                payload: { eodHistory }
              });
            }
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_EOD_HISTORY,
              payload: { eodHistory: [] }
            });
          }
        ),

      this.orderService
        .getAll(OA)
        .subscribe(
          (value: any) => {
            console.log(value);
            const { statusCode, errorMessage } = value;
            
            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type   : GET_JOBS,
                payload: { jobs: [] }
              });
              this.store.dispatch({
                type   : GET_ORDERS,
                payload: { orders: [] }
              });
              this.store.dispatch({
                type   : GET_PRODUCTS,
                payload: { products: [] }
              });
            } else {
              const { activeJobs: jobs, activeOrders: orders, products } = JSON.parse(value.body).data;
              console.log(`jobs`);
              console.log(jobs);
              console.log(`orders`);
              console.log(orders);
              // console.log(JSON.stringify(orders));

              console.log(`products`);
              console.log(products);

              const queuedMTSJobs = jobs.filter(job => job.status === QUEUED && job.makeToStock);

              const amazonOrders = orders.filter(order => order.customer.email === 'OAamazonDF@avery.com')
              
              let marketplace: any = MARKETPLACEEMAILS.map(email => email.toLowerCase());
              const marketplaceOrders = orders.filter(order => marketplace.includes(order.customer.email.toLowerCase()))
              
              const ptoOrders = orders.filter(order => order.orderType == PTO)


              this.store.dispatch({
                type: GET_QUEUED_MTS_JOBS,
                payload: { jobs: queuedMTSJobs }
              });
              this.store.dispatch({
                type   : GET_JOBS,
                payload: { jobs }
              });
              this.store.dispatch({
                type   : GET_ORDERS,
                payload: { orders }
              });
              this.store.dispatch({
                type   : GET_PRODUCTS,
                payload: { products}
              });
              this.store.dispatch({
                type   : GET_AMAZON_ORDERS,
                payload: { amazonOrders }
              });
              this.store.dispatch({
                type   : GET_MARKETPLACE_ORDERS,
                payload: { marketplaceOrders }
              });
              this.store.dispatch({
                type   : GET_PTO_ORDERS,
                payload: { ptoOrders }
              });
            }

            this.initCheck.next({ jobs: true, orders: true, products: true });
          },
          (error: Error) => {
            console.log(error);
            this.store.dispatch({
              type   : GET_JOBS,
              payload: { jobs: [] }
            });
            this.store.dispatch({
              type   : GET_ORDERS,
              payload: { orders: [] }
            });
            this.store.dispatch({
              type   : GET_PRODUCTS,
              payload: { products: [] }
            });
            this.store.dispatch({
              type   : GET_AMAZON_ORDERS,
              payload: { amazonOrders : []}
            });
            this.store.dispatch({
              type   : GET_MARKETPLACE_ORDERS,
              payload: { marketplaceOrders : []}
            });
            this.store.dispatch({
              type   : GET_PTO_ORDERS,
              payload: { ptoOrders : []}
            });

            this.initCheck.next({ jobs: true, orders: true, products: true });
          }
        ),
        
      this.mqttService
      .productListener
      .subscribe(({ payload }) => {
        const { type, sku, skus, body, diffList } = payload;
        console.log(payload)
        switch (type) {
          case UPDATE_PRODUCT: 
            if (sku) {
              console.log('UPDATE PRODUCT RESPONSE');
              console.log(payload);
              if(diffList){
                this.store.dispatch({
                  type   : UPDATE_PRODUCT,
                  payload: { sku, diffList }
                });
              }                
            }
            break;

        }
      }),
        // this.scrapService
        //   .getScrapHistory(OA, `${lastYear}-${lastMonthNumber}-01`, today)
        //   .subscribe(
        //     (value: any) => {
        //       console.log(value);
        //       const { statusCode, errorMessage } = value;

        //       if (statusCode === 400 || errorMessage) {
        //         this.store.dispatch({
        //           type: GET_SCRAPS,
        //           payload: { scraps: [] }
        //         });
        //       } else {
        //         const { scrapHistory: scraps } = JSON.parse(value.body).data;

        //         console.log(`scrap history`);
        //         console.log(scraps);

        //         this.store.dispatch({
        //           type: GET_SCRAPS,
        //           payload: { scraps }
        //         });
        //       }
        //     },
        //     (error: Error) => {
        //       console.log(error);
        //       this.store.dispatch({
        //         type: GET_SCRAPS,
        //         payload: { scraps: [] }
        //       });
        //     }
        //   ),

        this.scrapService
          .getActiveScraps()
          .subscribe(
            (value: any) => {
              console.log(value);
              const { statusCode, errorMessage } = value;

              if (statusCode === 400 || errorMessage) {
                this.store.dispatch({
                  type: GET_ACTIVE_SCRAPS,
                  payload: { scraps: [] }
                });
              } else {
                const { activeScraps } = JSON.parse(value.body).data;

                console.log(`active scraps`);
                console.log(activeScraps);

                this.store.dispatch({
                  type: GET_ACTIVE_SCRAPS,
                  payload: { scraps: activeScraps }
                });
              }
              
              this.initCheck.next({ scraps: true });
            },
            (error: Error) => {
              console.log(error);
              this.store.dispatch({
                type: GET_ACTIVE_SCRAPS,
                payload: { scraps: [] }
              });

              this.initCheck.next({ scraps: true });
            }
          ),

        this.shipmentService
          .getAllOA()
          .subscribe(
            (value: any) => {
              console.log(value);
              const { statusCode, errorMessage } = value;

              if (statusCode === 400 || errorMessage) {
                this.store.dispatch({
                  type   : GET_SHIPMENTS,
                  payload: { shipments: [] }
                });
                this.store.dispatch({
                  type   : GET_BINS,
                  payload: { bins: [] }
                });
                this.store.dispatch({
                  type   : GET_YELLOWBAGS,
                  payload: { yellowBags: [] }
                });
                this.store.dispatch({
                  type   : SET_SHIPMENT_LIST_VIEW,
                  payload: { error: this.translate.instant('SHIPMENTS_NOT_FOUND') }
                });
              } else {
                const { bins, activeShipments: shipments, yellowBags } = JSON.parse(value.body).data;
                console.log('bins');
                console.log(bins);
                console.log('shipments');
                console.log(shipments);
                console.log('yellow bags');
                console.log(yellowBags);

                this.store.dispatch({
                  type   : GET_BINS,
                  payload: { bins }
                });
                this.store.dispatch({
                  type   : GET_SHIPMENTS,
                  payload: { shipments }
                });
                this.store.dispatch({
                  type   : GET_YELLOWBAGS,
                  payload: { yellowBags }
                });
                this.initCheck.next({ shipments: true, bins: true });
              }

              this.store.dispatch({
                type   : SET_SHIPMENT_LIST_VIEW,
                payload: { loading: false }
              });
            },
            (error: Error) => {
              console.log(error);
              this.store.dispatch({
                type   : GET_SHIPMENTS,
                payload: { shipments: [] }
              });
              this.store.dispatch({
                type   : GET_BINS,
                payload: { bins: [] }
              });
              this.store.dispatch({
                type   : GET_YELLOWBAGS,
                payload: { yellowBags: [] }
              });
              this.initCheck.next({ shipments: true, bins: true });
            }
          ),
          // Move to shipment list?
          this.shipmentList
          .subscribe(shipments => {
            const MIDShipments = [];

            shipments.forEach(shipment => {
              if (!shipment.yellowBagID && shipment.shipmentStatus === SHIPPED && shipment.serviceType === 'M4') {
                let weight = 0;

                shipment.packages.forEach(pkg => weight += pkg.weight);

                MIDShipments.push({
                  id               : shipment.orderId,
                  estimatedDelivery: shipment.expectedDate,
                  jobs             : shipment.jobs,
                  include          : true,
                  weight
                });
              }
            });

            this.store.dispatch({
              type   : GET_MID_ORDERS,
              payload: { MID_orders: MIDShipments }
            });
          }),
        this.authService
          .getUsers()
          .subscribe(
            (value: any) => {
              console.log(value);
              const { errorMessage, statusCode } = value;
  
              if (statusCode === 400 || errorMessage) {
                this.store.dispatch({
                  type   : GET_USERS,
                  payload: { users: [] }
                });
              } else {
                const { users } = JSON.parse(value.body).data;
                console.log('users');
                console.log(users);
  
                this.store.dispatch({
                  type   : GET_USERS,
                  payload: { users }
                })
              }
  
              this.store.dispatch({
                type   : SET_USER_LIST_VIEW,
                payload: {
                  loading           : false,
                  userDetailsLoading: false
                }
              });
            },
            (error: Error) => {
              console.log(error);
              this.store.dispatch({
                type   : GET_USERS,
                payload: { users: [] }
              });
              this.store.dispatch({
                type   : SET_USER_LIST_VIEW,
                payload: {
                  loading           : false,
                  userDetailsLoading: false
                }
              });
            }
          ),
  
        this.settingService
          .getSettings()
          .subscribe(
            (value: any) => {
              console.log(value);
              const { statusCode, errorMessage } = value;
  
              if (statusCode === 400 || errorMessage) {
                this.store.dispatch({
                  type   : GET_SETTINGS,
                  payload: { settings: [] }
                });
              } else {
                const { settings } = JSON.parse(value.body).data;
                console.log('settings');
                console.log(settings);
  
                this.store.dispatch({
                  type   : GET_SETTINGS,
                  payload: { settings }
                });
              }
  
              this.store.dispatch({
                type   : SET_SETTING_LIST_VIEW,
                payload: { loading: false }
              });
            },
            (error: Error) => {
              console.log(error);
              this.store.dispatch({
                type: SET_SETTING_LIST_VIEW,
                payload: { loading: false }
              });
            }
          ),

        this.templateService
          .getTemplates()
          .subscribe(
            (value: any) => {
              console.log(value);
              const { statusCode, errorMessage } = value;
  
              if (statusCode === 400 || errorMessage) {
                this.store.dispatch({
                  type: GET_TEMPLATES,
                  payload: { templates: [] }
                });
                this.store.dispatch({
                  type: SET_TEMPLATE_LIST_VIEW,
                  payload: { error: this.translate.instant('TEMPLATES_NOT_FOUND') } 
                });
              } else {
                const { templates } = JSON.parse(value.body).data;
                console.log(`templates`);
                console.log(templates);
                
                this.store.dispatch({
                  type: GET_TEMPLATES,
                  payload: { templates }
                });
                this.store.dispatch({
                  type: SET_TEMPLATE_LIST_VIEW,
                  payload: { error: '' }
                });
              }
  
              this.store.dispatch({
                type   : SET_TEMPLATE_LIST_VIEW,
                payload: { loading: false }
              });
              this.store.dispatch({
                type   : SET_TEMPLATE_EDIT_FORM,
                payload: { loading: false }
              });
            },
            (error: Error) => {
              console.log(error);
              this.store.dispatch({
                type: GET_TEMPLATES,
                payload: { templates: [] }
              });
              this.store.dispatch({
                type: SET_TEMPLATE_LIST_VIEW,
                payload: { 
                  error: this.translate.instant('TEMPLATES_NOT_FOUND'),
                  loading: false
                } 
              });
              this.store.dispatch({
                type   : SET_TEMPLATE_EDIT_FORM,
                payload: { loading: false }
              });
            }
          ),

        this.templateService
          .getTemplatePDFList()
          .subscribe(
            (pdfs: any[]) => {
              const pdfList = pdfs.map(pdf => {
                const { key, url } = pdf;
  
                return { key, url };
              });
              console.log('template PDFs');
              console.log(pdfList);
  
              this.store.dispatch({
                type   : GET_TEMPLATE_PDFS,
                payload: { pdfs: pdfList }
              });
              this.store.dispatch({
                type   : SET_TEMPLATE_OVERLAY_VIEW,
                payload: { loading: false }
              });
            },
            (error: Error) => {
              console.log(error);
  
              this.store.dispatch({
                type   : GET_TEMPLATE_PDFS,
                payload: { pdfs: [] }
              });
              this.store.dispatch({
                type   : SET_TEMPLATE_OVERLAY_VIEW,
                payload: { loading: false }
              });
            }
          ),

      this.systemSettingList
        .subscribe(settings => {
          const nextBusinessDaySetting = settings && settings.find(setting => setting.name === 'SYSTEM.SETTING.NEXT_BUSINESS_DAY_OA.NAME');
          const nextBusinessDay = nextBusinessDaySetting && nextBusinessDaySetting.value;
          const eodSetting = settings && settings.find(setting => setting.name === 'SYSTEM.SETTING.ENABLE_OA_EOD.NAME');
          this.allowEod = eodSetting ? (eodSetting.value === 'true' ? true : false) : false;
          console.log(`next business day: ${nextBusinessDay}`);

          this.store.dispatch({
            type: GET_NEXT_BUSINESS_DAY,
            payload: { nextBusinessDay }
          });

          this.store.dispatch({
            type: SET_SETTING_LIST_VIEW,
            payload: { loading: false }
          });
        }),

      this.shipmentList
        .subscribe(shipments => {
          const RTS = [];
          let jobs = 0, packages = 0, rtsAll = 0;
          let shipmentsCommentMap = {};
          shipments.forEach(shipment => {
            if (shipment.shipmentStatus === SHIPPED && (shipment.trackingNumberUPS || shipment.trackingNumberUSPS || shipment.trackingNumberFEDEX)) {
              // console.log("shipment dueDate: ",shipment.dueDate)
              rtsAll++;
              if(moment(shipment.dueDate, 'YYYY-MM-DD').isBefore(moment(this.nextBusinessDate, 'YYYY-MM-DD').add(1,'day'))) {
                RTS.push(shipment);
                jobs += shipment.jobs.length;
                packages += shipment.packages.length;
              }
            }
            if(shipment.activity_history) {
              const hasComment = this.commentOrder(shipment.activity_history);
              if(hasComment) {
                shipmentsCommentMap[shipment.id] = hasComment;
              }
            }
          });
          this.store.dispatch({
            type   : SET_COMMENT_SHIPMENT_MAP,
            payload: { shipmentsCommentMap }
          });

          this.store.dispatch({
            type: GET_RTS_TOTALS,
            payload: { RTS, jobs, packages, rtsAll }
          })
        }),
        
      this.jobList
        .subscribe(jobs=> {
          const jobsCommentMap = {};
          jobs.forEach(job=>{
            const hasComment = this.commentOrder(job.activity_history);
            if(hasComment) {
              jobsCommentMap[job.id] = true;
            }
          })
          this.store.dispatch({
            type   : SET_COMMENT_JOBS_MAP,
            payload: { jobsCommentMap }
          });
        }),

      this.prestaSubassemblyService
        .getAll()
        .subscribe(
          (value: any) => {
            console.log(value);
            const { errorMessage, statusCode } = value;

            if (statusCode === 400 || errorMessage) {
              this.store.dispatch({
                type: GET_LASER_PRESTA_MATERIAL_CONFIG,
                payload: { listPrestaSubassemblyConfigs: [] }
              });
            } else {
              const { listPrestaSubassemblyConfigs } = JSON.parse(value.body).data;

              console.log(`listPrestaSubassemblyConfigs`);
              console.log(listPrestaSubassemblyConfigs);

              this.store.dispatch({
                type: GET_LASER_PRESTA_MATERIAL_CONFIG,
                payload: { listPrestaSubassemblyConfigs }
              });

            }
          },
          (error: Error) => {
            console.log(error);

            this.store.dispatch({
              type: GET_LASER_PRESTA_MATERIAL_CONFIG,
              payload: { listPrestaSubassemblyConfigs: [] }
            });

          }
        ),

      Observable
        .combineLatest( 
          this.lastEODRanToday,
          this.orderList, 
          this.shipmentList,
          this.nextBusinessDay
        )
        .subscribe(([ lastEODRanToday, orders, shipments, nextBusinessDay ]) => {
          // this.queryList = [ ...jobs, ...orders ];

          this.nextBusinessDate = nextBusinessDay;
          let lateJobs = 0, dueTodayJobs = 0, currentlyDueJobs = 0;
          const today = moment().format('YYYY-MM-DD');
          const currentlyDueOrders = [],
                dueTodayOrders = [], 
                // dueTomorrowOrders = [], 
                dueNextBusinessDayOrders = [],
                reprintOverdueOrders = [], 
                overdueOrders = [], 
                reprintOrders = [], 
                normalOrders = [], 
                RTSOrders = [],
                addressInvalidOrders = [],
                pendingPrintOrders = [],
                prePressOrders = [];
          let serviceTypeSelect = {},
              dueDateSelect = {},
              deliveryDateSelect = {},
              customerDueDateSelect = {},
              daysUntilDueSelect = {},
              ordersCommentMap = {};
          this.nextBusinessDate = nextBusinessDay;
              // console.log("this.nbd : ",this.nextBusinessDate)
          if(typeof this.nextBusinessDate === 'string') {
            const diffNBDAndToday = moment((nextBusinessDay)).diff(moment(today), 'days', true);
            // console.log("diffNBDAndToday: ", diffNBDAndToday > 0)
            this.store.dispatch({
              type: GET_LAST_EOD_RAN_TODAY,
              payload: { lastEODRanToday :  diffNBDAndToday}
            });
          }
          orders && orders.forEach(order => {
            if (order.status !== CANCELLED && order.status !== EOD_COMPLETED) {
              const shipment = shipments.find(shipment => shipment.orderId === order.id);
              const daysUntilDue = Math.ceil(moment(order.shipment.production_due_date).diff(moment(), 'days', true));
              const diffNBD = moment((nextBusinessDay || today)).diff(moment(order.shipment.production_due_date), 'days', true);
              const hasComment = this.commentOrder(order.activity_history);
              if(hasComment) {
                ordersCommentMap[order.id] = hasComment;
              }
              const formattedOrder = Object.assign({}, order, {
                hasShippingLabel: !!(shipment && shipment.shipmentStatus === SHIPPED && (shipment.trackingNumberUPS || shipment.trackingNumberUSPS || shipment.trackingNumberFEDEX))
              });
  
              if (formattedOrder.hasShippingLabel) {
                RTSOrders.push(formattedOrder);
              } 
              
              if (!formattedOrder.hasShippingLabel && +daysUntilDue === 0 && diffNBD <= 0) {
                dueTodayOrders.push(formattedOrder);
                dueTodayJobs += formattedOrder.jobs.length;

                if (!lastEODRanToday) {
                  currentlyDueOrders.push(formattedOrder);
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              } 
  
              if(formattedOrder.address.validated === false && (shipment && shipment.shipmentStatus != SHIPPED)) {
                addressInvalidOrders.push(formattedOrder);
              }
              // if (!formattedOrder.hasShippingLabel && +daysUntilDue === 1 && diffNBD <= 0) {
              //   dueTomorrowOrders.push(formattedOrder);

              //   if (lastEODRanToday) {
              //     currentlyDueJobs += formattedOrder.jobs.length;
              //   }
              // }

              if (!formattedOrder.hasShippingLabel && diffNBD === 0) {
                dueNextBusinessDayOrders.push(formattedOrder);

                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }

              if (!formattedOrder.hasShippingLabel && order.reprint && diffNBD > 0) {
                reprintOverdueOrders.push(formattedOrder);
                lateJobs += formattedOrder.jobs.length;
                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }
  
              if (!formattedOrder.hasShippingLabel && !order.reprint && diffNBD > 0) {
                overdueOrders.push(formattedOrder);
                lateJobs += formattedOrder.jobs.length;
                if (lastEODRanToday) {
                  currentlyDueJobs += formattedOrder.jobs.length;
                }
              }
  
              if (!formattedOrder.hasShippingLabel && order.reprint && diffNBD <= 0) {
                reprintOrders.push(formattedOrder);
              }

              if(formattedOrder.status === PENDING_PRINTING) {
                pendingPrintOrders.push(formattedOrder);
              }

              if (!formattedOrder.hasShippingLabel && !order.reprint && diffNBD <= 0) {
                normalOrders.push(formattedOrder);
              }

              if(formattedOrder.shipment.shipping_method && serviceTypeSelect[formattedOrder.shipment.shipping_method]) {
                serviceTypeSelect[formattedOrder.shipment.shipping_method]++;
              } else {
                serviceTypeSelect[formattedOrder.shipment.shipping_method] = 1;
              }

              if(formattedOrder.dueDate && dueDateSelect[formattedOrder.dueDate]) {
                dueDateSelect[formattedOrder.dueDate]++;
              } else {
                dueDateSelect[formattedOrder.dueDate] = 1;
              }

              if(formattedOrder.shipment.estimated_delivery_date && deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date]) {
                deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date]++;
              } else {
                deliveryDateSelect[formattedOrder.shipment.estimated_delivery_date] = 1;
              }

              if(formattedOrder.shipment.customer_desired_due_date && customerDueDateSelect[formattedOrder.shipment.customer_desired_due_date]) {
                customerDueDateSelect[formattedOrder.shipment.customer_desired_due_date]++;
              } else {
                customerDueDateSelect[formattedOrder.shipment.customer_desired_due_date] = 1;
              }

              if((!formattedOrder.hasShippingLabel && diffNBD > 0) && formattedOrder.status !== 'shipping') {
                  if(formattedOrder.shipment.production_due_date && daysUntilDueSelect[formattedOrder.shipment.production_due_date] ) {
                    daysUntilDueSelect[formattedOrder.shipment.production_due_date]++;
                  } else {
                    daysUntilDueSelect[formattedOrder.shipment.production_due_date] = 1;
                  }
              } 
            }
          });
          if(serviceTypeSelect['ups_03']) {
            if(serviceTypeSelect['flatrate_ups_03']) {
              serviceTypeSelect['ups_03'] += serviceTypeSelect['flatrate_ups_03'];
              delete serviceTypeSelect['flatrate_ups_03'];
            }
            if(serviceTypeSelect['freeshipping_ups_03']) {
              serviceTypeSelect['ups_03'] += serviceTypeSelect['freeshipping_ups_03'];
              delete serviceTypeSelect['freeshipping_ups_03'];
            }
          }
          if(serviceTypeSelect['usps_4']) {
            if(serviceTypeSelect['usps_1']) {
              serviceTypeSelect['usps_4'] += serviceTypeSelect['usps_1'];
              delete serviceTypeSelect['usps_1'];
            }
          }
          serviceTypeSelect = Object.keys(serviceTypeSelect).reduce((arr, key)=>{
            const subObj = { type: SERVICE, id: key, qty : serviceTypeSelect[key], name: this.translate.instant(key.toUpperCase())};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.name > b.name) ? 1 : -1);
          deliveryDateSelect = Object.keys(deliveryDateSelect).reduce((arr, key)=>{
            const subObj = { type: DELIVERYDATE, id: key, qty : deliveryDateSelect[key]};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.id > b.id) ? 1 : -1);
          customerDueDateSelect = Object.keys(customerDueDateSelect).reduce((arr, key)=>{
            const subObj = { type: CUSTOMERDUE, id: key, qty : customerDueDateSelect[key]};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.id > b.id) ? 1 : -1);
          dueDateSelect = Object.keys(dueDateSelect).reduce((arr, key)=>{
            const subObj = { type: DUEDATE, id: key, qty : dueDateSelect[key]};
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.id > b.id) ? 1 : -1);
          daysUntilDueSelect = Object.keys(daysUntilDueSelect).reduce((arr, key)=>{
            const subObj = { type: DAYSUNTILDUE, id: key, qty : daysUntilDueSelect[key], name: this.daysUntilDue.transform(nextBusinessDay, key)['daysUntilDueMsg'] };
            return arr.concat(subObj)
          }, []).sort((a, b) => (a.name > b.name) ? 1 : -1);

          if (lastEODRanToday) {
            currentlyDueOrders.push(
              ...reprintOverdueOrders,
              ...overdueOrders,
              // ...dueTomorrowOrders,
              ...dueNextBusinessDayOrders
            );
          }

          this.store.dispatch({
            type   : GET_FILTERED_ORDERS,
            payload: { 
              addressInvalidOrders,
              currentlyDueOrders,
              currentlyDueJobs,
              dueTodayOrders,
              // dueTomorrowOrders,
              dueNextBusinessDayOrders,
              reprintOverdueOrders,
              overdueOrders,
              reprintOrders,
              normalOrders,
              RTSOrders,
              pendingPrintOrders,
              serviceTypeSelect,
              deliveryDateSelect,
              customerDueDateSelect,
              dueDateSelect,
              daysUntilDueSelect,
              prePressOrders
            }
          });
          this.store.dispatch({
            type   : SET_COMMENT_ORDERS_MAP,
            payload: { ordersCommentMap }
          });
          this.store.dispatch({
            type: SET_MAIN_VIEW,
            payload: {
              dueTodayJobs,
              lateJobs
            }
          });
        }),

      this.eodList
        .subscribe(eodHistory => {
          const eodProcessing = eodHistory.some(eod => !!eod.processing);

          const lastEODRanToday = !!eodHistory.find(eod => {
            const ranToday = moment(eod.runDate, 'x').format('YYYY-MM-DD') === today;

            return ranToday && eod.lastOfDay;
          });

          console.log(`Last EOD ran today: ${lastEODRanToday}`);

          this.store.dispatch({
            type   : SET_MAIN_VIEW,
            payload: { eodOAProcessing: eodProcessing }
          });
          
          this.store.dispatch({
            type: GET_LAST_EOD_RAN_TODAY,
            payload: { lastEODRanToday }
          });
        }),

      Observable
        .combineLatest(
          this.RTSOrders,
          this.currentlyDueOrders, 
          this.reprintOverdueOrders,
          this.overdueOrders
        )
        .subscribe(([ rtsTotal, currentlyDueOrders, reprintOverdueOrders, overdueOrders ]) => {
          if((rtsTotal) && (currentlyDueOrders && currentlyDueOrders.orders) && reprintOverdueOrders && overdueOrders) {
            this.progressPercent = rtsTotal.length / (
              rtsTotal.length + 
              currentlyDueOrders.orders.length  + 
              reprintOverdueOrders.length + 
              overdueOrders.length) * 100;
            this.progressPercent = this.progressPercent > 100 ? 100 : Math.round(this.progressPercent);
          }
        }),
    ];
  }

  ngOnDestroy(): void {
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());

    this.store.dispatch({ type: _CLEAR });
  }

  logout(): void {
    this.authService.logout();
  }

  intersectUnique(arr1, arr2): any[] {
    if (!arr1 || !arr1.length || !arr2 || !arr2.length) return [];
    const intersect = (a, b) => {
      let t;
      if (b.length > a.length) t = b, b = a, a = t;
      return a.filter(e => {
        return b.indexOf(e) > -1;
      });
    };

    return intersect(arr1, arr2).filter((e, i, c) => c.indexOf(e) === i);
  }

  groupBy(arr, property): any {
    return arr.reduce((memo, x) => {
      if (!memo[x[property]]) { memo[x[property]] = []; }
      memo[x[property]].push(x);
      return memo;
    }, {});
  }

  commentOrder (activityHistory) {
    let found = false;
    for(var i = 0; i < activityHistory.length; i++) {
      if (activityHistory[i] && activityHistory[i].activity == 'comment') {
            found = true;
            break;
        }
    }
    return found;
  }

  openProcessEODModal(): void {
    if(this.allowEod) {
      this.shipmentService.processEOD.next();
    }
  }

  queryListNoResults(event: Event): void {
    this.queryListNoMatch = !!event;
  }

  searchQuery(query: string): void {
    const prefix = query.slice(0, 2).toLowerCase();
    query = query.replace(/\D+/g, "");
    this.query = query;
    console.log(`search query: "${query}"`);

    Observable
      .combineLatest(
        this.jobList, 
        this.orderList,
        this.shipmentList
      )
      .take(1)
      .subscribe(
        ([ jobs, orders, shipments ]) => {
          const order = orders.find(order => {
            return order.id === `OA${query}`;
          });
          const job   = jobs.find(job => job.id === query);
          const shipment = shipments.find(shipment => (order && shipment.orderId === order.id) || (job && shipment.orderId === job.orderId));
          const oneNonShippingJob = shipment ? !!jobs.filter(job => (<any>shipment.jobs).includes(job.id)).find(job => job.status != "shipping") : false;

          
          if ((order && oneNonShippingJob) || (order)) {
            this.router.navigate(['oa/dashboard/orders/all', order.id]);
          } else if ((job && oneNonShippingJob) || (job && job.status !== 'shipping')) {
            this.router.navigate(['oa/dashboard/jobs/all', job.id]);
          } else if ((shipment && !oneNonShippingJob) || (shipment && !order && !job)) {
            this.router.navigate(['oa/dashboard/shipping/all', shipment.id]);
          } else if(!order && !shipment && !job) {
            this.orderService.getArchivedOrder.next({ id: query, category: OA });
          }
        },
        (error: Error) => console.log(error)
      );
  }

  setLang(lang: string, url: string): void {
    this.language = { lang, url };
    // localStorage.setItem('language', lang);
    // this.translate.use(lang);
    if(localStorage.getItem('language') && localStorage.getItem('language') != lang) {
      localStorage.setItem('language', lang);
      this.translate.use(lang);
      window.location.reload();
    }
  }

  switchDashboard(dashboard : string): void {
    console.log("🚀 ~ dashboard:", dashboard)
    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: { dashboardSwitch: true }
    });
    this.store.dispatch({ type: _CLEAR });
    if(dashboard == RFID){
      this.router.navigate(['/rfid/dashboard/orders/all']);
    }else if(dashboard == OA){
      this.router.navigate(['/oa/dashboard/orders/all']);
    }else {
      this.router.navigate(['/dashboard/orders/all']);
    }
    this.store.dispatch({
      type   : SET_MAIN_VIEW,
      payload: { dashboardSwitch: false }
    });
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/layouts/online-aisle-layout.component.ts